var isUnder18 = true;

$(function () {
    initEvents();
    initValidation();
    initDocumentUpload();
});

function initEvents() {
    $('#ReleaseSignature').on('input', function () {
        if ($.trim($(this).val()) === $('#LegalName').val()) {
            $('#submitApplicationButton').removeClass('disabled').removeAttr('disabled');
        }
        else {
            $('#submitApplicationButton').addClass('disabled').attr('disabled', 'disabled');
        }
    });

    $('#submitApplicationButton').click(function () {
        if ($('#volunteerForm').valid() && $.trim($('#ReleaseSignature').val()) === $('#LegalName').val()) {
            $('#submitApplicationButton').addClass('disabled').attr('disabled', 'disabled');
            $('#volunteerForm').submit();
        }
    });

    $('input:checkbox.primaryPhone').click(function () {
        $('input:checkbox.primaryPhone').not(this).removeAttr("checked");
    });

    $('.specialSkillCategoryCheckbox').change(function () {
        var specialSkillCategoryId = $(this).data('specialSkillCategoryId');

        var childSpeicalSkillCheckboxes = $('.specialSkillCheckbox').filter('[data-special-skill-category-id="' + specialSkillCategoryId + '"]');

        var isSelected = $(this).is(':checked');

        childSpeicalSkillCheckboxes.prop('checked', isSelected);

        if (isSelected) {
            $(this).parents('.specialSkillCategoryContainer').find('.specialSkillContainer').removeClass('hidden');
        }
        else {
            $(this).parents('.specialSkillCategoryContainer').find('.specialSkillContainer').addClass('hidden');
        }
    });

    $('#Over18Certification').on('click', function () {
        if ($(this).is(':checked')) {
            $('#ParentPanel').addClass('hidden');
        } else {
            $('#ParentPanel').removeClass('hidden');
        }
    });
}

function initValidation() {
    $.validator.addMethod("zipcodeUS", function (value, element) {
        return this.optional(element) || /\d{5}-\d{4}$|^\d{5}$/.test(value);
    });

    $.validator.addMethod('minDate', function (v, el, minDate) {
        if (this.optional(el)) {
            return true;
        }

        return minDate.setHours(0, 0, 0, 0) <= new Date(v).setHours(0, 0, 0, 0);
    }, 'Date must be in the future.');

    $.validator.addMethod("primaryPhone", function (value, elem, param) {
        if ($('input:checkbox.primaryPhone:checked').length > 0) {
            return true;
        } else {
            return false;
        }
    }, "Primary phone is required.");

    $.validator.addMethod("singlePrimaryPhone", function (value, elem, param) {
        if ($('input:checkbox.primaryPhone:checked').length <= 1) {
            return true;
        } else {
            return false;
        }
    }, "You may only select 1 primary phone number.");

    var eighteenYears = new Date();
    eighteenYears.setFullYear(eighteenYears.getFullYear() - 18);

    $.validator.addMethod('maxDateIfChecked', function (v, el, id) {
        if ($(id).is(':checked')) {
            return eighteenYears >= new Date(v);
        }
        else {
            return true;
        }
    }, 'Parent information must be included if signee birthday indicates they are under 18.');

    var options = extendValidationSettings({
        errorContainer: '.errorMessageBox',
        errorLabelContainer: '.errorList',
        errorElement: "li",
        rules: {
            Address1: "required",
            City: "required",
            State: "required",
            ZipCode: {
                required: true,
                zipcodeUS: true
            },
            EducationLevel: {
                required: true
            },
            IsMobilePhonePrimary: {
                primaryPhone: true,
                singlePrimaryPhone: true
            },
            MobilePhone: {
                required: "#IsMobilePhonePrimary:checked",
                phoneUS: true
            },
            HomePhone: {
                required: "#IsHomePhonePrimary:checked",
                phoneUS: true
            },
            WorkPhone: {
                required: "#IsWorkPhonePrimary:checked",
                phoneUS: true
            },
            LegalFirstName: {
                required: true,
                minlength: 2,
                maxlength: 50
            },
            LegalLastName: {
                required: true,
                minlength: 2,
                maxlength: 50
            },
            HasBackgroundConviction: "required",
            BackgroundConvictionNotes: {
                required: function (element) {
                    return $("[name='HasBackgroundConviction']:checked").val() === "true";
                }
            },
            DateOfBirth: {
                required: '#DateOfBirth:visible',
                date: true,
                maxDateIfChecked: '#Over18Certification'
            },
            DriversLicenseExpiration: {
                required: function () {
                    return $("#DriversLicenseNumber").val().length > 0;
                },
                date: true,
                minDate: new Date()
            },
            EmergencyContactName: {
                required: isEmergencyContactRequired
            },
            EmergencyContactRelationship: {
                required: isEmergencyContactRequired
            },
            EmergencyContactPhoneNumber: {
                required: isEmergencyContactRequired,
                phoneUS: true
            },
            VolunteerGroups: {
                required: 'input[name="VolunteerGroups"]:visible'
            },
            ReleaseSignature: {
                required: true
            },
            WaiverParentName: {
                required: {
                    depends: function () {
                        return ($('#Over18Certification').is(':checked') == false);
                    }
                }
            },
            WaiverParentRelationship: {
                required: {
                    depends: function () {
                        return ($('#Over18Certification').is(':checked') == false);
                    }
                }
            },
            WaiverParentEmail: {
                required: {
                    depends: function () {
                        return ($('#Over18Certification').is(':checked') == false);
                    }
                },
                email: true,
                remote: {
                    url: "/api/UserAccountValidEmail",
                    type: "post"
                }
            },
            WaiverParentPhone: {
                required: {
                    depends: function () {
                        return ($('#Over18Certification').is(':checked') == false);
                    }
                },
                phoneUS: true
            },
            WaiverParentSignature: {
                required: {
                    depends: function () {
                        return ($('#Over18Certification').is(':checked') == false);
                    }
                },
                trimEqualTo: '#WaiverParentName'
            }
        },
        messages: {
            Address1: "Address is required.",
            City: "City is required.",
            State: "State is required.",
            ZipCode: {
                required: "Zip is required.",
                zipcodeUS: "Zip is invalid."
            },
            EducationLevel: "Education Attainment is required.",
            LegalFirstName: {
                required: 'Legal First Name is required.',
                minlength: jQuery.validator.format('Legal First Name must be at least {0} characters.'),
                maxlength: jQuery.validator.format('Legal First Name must be less than {0} characters.')
            },
            LegalLastName: {
                required: 'Legal Last Name is required.',
                minlength: jQuery.validator.format('Legal Last Name must be at least {0} characters.'),
                maxlength: jQuery.validator.format('Legal Last Name must be less than {0} characters.')
            },
            HasBackgroundConviction: "Background Yes/No is required.",
            BackgroundConvictionNotes: {
                required: "Conviction notes are required."
            },
            IsMobilePhonePrimary: {
                primaryPhone: 'Primary phone is required.',
                singlePrimaryPhone: 'You may only select 1 primary phone number.'
            },
            MobilePhone: {
                required: "Primary Phone Number is required.",
                phoneUS: 'Mobile Phone is invalid.'
            },
            HomePhone: {
                required: "Primary Phone Number is required.",
                phoneUS: 'Home Phone is invalid.'
            },
            WorkPhone: {
                required: "Primary Phone Number is required.",
                phoneUS: 'Work Phone is invalid.'
            },
            DateOfBirth: {
                required: "Birthday is required.",
                date: "Birthday must be a valid date."
            },
            DriversLicenseExpiration: {
                required: 'Drivers License Expiration is required.',
                date: 'Drivers License Expiration must be a valid date.',
                minDate: 'Drivers License Expiration must be in the future.'
            },
            EmergencyContactName: {
                required: 'Emergency Contact Name is required.'
            },
            EmergencyContactRelationship: {
                required: 'Emergency Contact Phone is required.'
            },
            EmergencyContactPhoneNumber: {
                required: 'Emergency Contact Phone is required.',
                phoneUS: 'Emergency Contact Phone is invalid.'
            },
            VolunteerGroups: {
                required: 'You must select at least one from Volunteer Groups To Apply For.'
            },
            ReleaseSignature: {
                required: "You must type your full legal name to sign the waiver."
            },
            WaiverParentName: {
                required: "Parent/Guardian Full Legal Name is required.",
            },
            WaiverParentRelationship: {
                required: "Parent/Guardian Relationship is required.",
            },
            WaiverParentEmail: {
                required: "Parent/Guardian Email is required.",
                email: "Parent/Guardian Email must be a valid email address."
            },
            WaiverParentPhone: {
                required: "Parent/Guardian Phone is required.",
                phoneUS: "Parent/Guardian Phone must be a valid phone number."
            },
            WaiverParentSignature: {
                required: "Your Parent/Guardian must type their full legal name to sign the waiver.",
                trimEqualTo: "Parent/Guardian signature must match Parent/Guardian Full Legal Name"
            }
        }
    });

    var extended = {
        rules: {
            CanAttendTraining: "required",
            HasReadJobDescription: "required"
        },
        messages: {
            CanAttendTraining: "You must check: 'I can attend scheduled trainings'.",
            HasReadJobDescription: "You must check: 'I've read the position description'."
        }
    };

    var referenceCount = $('#ReferencesCount').val();
    for (var i = 0; i < referenceCount; i++) {
        extended.rules["Reference_" + i + "_FirstName"] = "required";
        extended.messages["Reference_" + i + "_FirstName"] = "Reference " + (i + 1) + " First Name is required.";

        extended.rules["Reference_" + i + "_LastName"] = "required";
        extended.messages["Reference_" + i + "_LastName"] = "Reference " + (i + 1) + " Last Name is required.";

        extended.rules["Reference_" + i + "_HomePhone"] = {
            required: true,
            phoneUS: true
        };
        extended.messages["Reference_" + i + "_HomePhone"] = {
            required: "Reference " + (i + 1) + " Home/Primary Phone is required.",
            phoneUS: "Reference " + (i + 1) + " Home/Primary Phone is invalid."
        };

        extended.rules["Reference_" + i + "_CellPhone"] = {
            phoneUS: true
        };
        extended.messages["Reference_" + i + "_CellPhone"] = {
            phoneUS: "Reference " + (i + 1) + " Mobile Phone is invalid."
        };

        extended.rules["Reference_" + i + "_WorkPhone"] = {
            phoneUS: true
        };
        extended.messages["Reference_" + i + "_WorkPhone"] = {
            phoneUS: "Reference " + (i + 1) + " Work Phone is invalid."
        };

        extended.rules["Reference_" + i + "_Relationship"] = "required";
        extended.messages["Reference_" + i + "_Relationship"] = "Reference " + (i + 1) + " Relationship is required.";

        extended.rules["Reference_" + i + "_EmailAddress"] = "email";
        extended.messages["Reference_" + i + "_EmailAddress"] = "Reference " + (i + 1) + " Email must be a valid email address.";
    }

    var workHistoryCount = $('#WorkHistoryCount').val();
    for (var j = 0; j < workHistoryCount; j++) {
        extended.rules["WorkHistory_" + j + "_FirstName"] = {
            required: "#WorkHistory_" + j + "_EmployerName:filled"
        };
        extended.messages["WorkHistory_" + j + "_FirstName"] = {
            required: "Work History " + (j + 1) + " First Name is required."
        };

        extended.rules["WorkHistory_" + j + "_LastName"] = {
            required: "#WorkHistory_" + j + "_EmployerName:filled"
        };
        extended.messages["WorkHistory_" + j + "_LastName"] = {
            required: "Work History " + (j + 1) + " Last Name is required."
        };

        extended.rules["WorkHistory_" + j + "_WorkPhone"] = {
            required: "#WorkHistory_" + j + "_EmployerName:filled",
            phoneUS: true
        };
        extended.messages["WorkHistory_" + j + "_WorkPhone"] = {
            required: "Work History " + (j + 1) + " Work/Primary Phone is required.",
            phoneUS: "Work History " + (j + 1) + " Work/Primary Phone is invalid."
        };

        extended.rules["WorkHistory_" + j + "_CellPhone"] = {
            phoneUS: true
        };
        extended.messages["WorkHistory_" + j + "_CellPhone"] = {
            phoneUS: "Work History " + (j + 1) + " Mobile Phone is invalid."
        };

        extended.rules["WorkHistory_" + j + "_StartDate"] = {
            date: true
        };
        extended.messages["WorkHistory_" + j + "_StartDate"] = {
            date: "Work History " + (j + 1) + " Start Date must be a valid date."
        };

        extended.rules["WorkHistory_" + j + "_EndDate"] = {
            date: true
        };
        extended.messages["WorkHistory_" + j + "_EndDate"] = {
            date: "Work History " + (j + 1) + " End Date must be a valid date."
        };
    }

    options = $.extend(true, {}, options, extended);

    $('#volunteerForm').validate(options);
}

function initDocumentUpload() {
    var documentUploader = $('#documentUpload').fineUploader({
        request: {
            endpoint: '/UserAccountVolunteerApplicationDocumentUpload/',
            sizeLimit: 9437184
        },
        validation: {
            allowedExtensions: ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf'],
            sizeLimit: 29989273
        },
        multiple: true,
        autoUpload: false,
        template: 'documentUploadTemplate'
    }).on('upload', function (event, id, name) {
        var fileItemContainer = $(this).fineUploader('getItemByFileId', id);
        var fileDescription = $(fileItemContainer).find('.qq-edit-file-description').val();

        var params = {
            volunteerApplicationId: volunteerApplicationId,
            fileDescription: fileDescription,
        };

        $(this).fineUploader('setParams', params, id);
    }).on('submit', function () {
    }).on('complete', function (event, id, filename, responseJSON) {
        if (responseJSON.success) {
            $('#uploadedDocumentsTable').append("<tr><td class='text-success'>" + filename + "</td><td title='" + responseJSON.FileDescription + "'>" + responseJSON.ShortFileDescription + "</td></tr>");

            $('.qq-upload-list .qq-upload-success').remove();

            $('<input>').attr({
                type: 'hidden',
                id: 'VolunteerDocumentId',
                name: 'VolunteerDocumentId',
                value: responseJSON.UserAccountDocumentId
            }).appendTo('#volunteerForm');
        }
    });

    $('#uploadFilesButton').click(function () {
        $('#documentUpload').fineUploader('uploadStoredFiles');
    });
}